module.exports = __webpack_public_path__ + "static/media/S4N1.4c7832c0.svg";